import React, { useEffect } from "react";
import { Alert, Box, Chip, Container, Divider, Link as MUILink, Paper, Stack, Typography } from "@mui/material";
import { Link, Navigate } from "react-router-dom";
import { getLegalDocument } from "../legal/documents";

export default function LegalDocument({ type }) {
  const document = getLegalDocument(type);

  useEffect(() => {
    if (!document) return undefined;
    const previousTitle = window.document.title;
    window.document.title = `${document.title} | Band-Joe`;
    return () => {
      window.document.title = previousTitle;
    };
  }, [document]);

  if (!document) return <Navigate to="/" replace />;

  return (
    <Container maxWidth="md" sx={{ py: { xs: 4, md: 7 } }}>
      <Paper component="article" elevation={0} sx={{ border: 1, borderColor: "divider", borderRadius: 3, p: { xs: 2.5, sm: 5 } }}>
        <Stack spacing={3}>
          <Box>
            <Typography component="h1" variant="h3" fontWeight={900} gutterBottom>
              {document.title}
            </Typography>
            <Typography color="text.secondary">{document.summary}</Typography>
            <Stack direction="row" useFlexGap flexWrap="wrap" spacing={1} sx={{ mt: 2 }}>
              <Chip size="small" label={`Effective 30 July 2026`} />
              <Chip size="small" variant="outlined" label={`Version ${document.version}`} />
              <Chip size="small" variant="outlined" label="South Africa · English" />
            </Stack>
          </Box>
          <Alert severity="info">
            This is the current English (South Africa) legal document. Save or print a copy for your records.
          </Alert>
          <Divider />
          {document.sections.map(([heading, paragraphs]) => (
            <Box component="section" key={heading}>
              <Typography component="h2" variant="h5" fontWeight={800} gutterBottom>
                {heading}
              </Typography>
              <Stack spacing={1.5}>
                {paragraphs.map((paragraph) => (
                  <Typography key={paragraph} color="text.secondary" sx={{ lineHeight: 1.75 }}>
                    {paragraph}
                  </Typography>
                ))}
              </Stack>
            </Box>
          ))}
          <Divider />
          <Typography variant="body2" color="text.secondary">
            Also read our{" "}
            <MUILink component={Link} to={type === "terms" ? "/privacy" : "/terms"}>
              {type === "terms" ? "Privacy Policy" : "Terms of Service"}
            </MUILink>
            .
          </Typography>
        </Stack>
      </Paper>
    </Container>
  );
}
